/**
 * Shared deck-builder draft constants.
 *
 * Imported by every lobby surface that renders the draft format selector or
 * the post-draft summary: `components/lobby/DeckDraftSection`,
 * `pages/DraftPage` (header blurb), and the draft-complete summary card.
 *
 * Ids match the values the server validates in `draft_settings` /
 * `start_draft` — keep this list in sync with backend/server.py if you add
 * a new format.
 */

export const DRAFT_FORMATS = [
  { id: "pack", label: "Pack",
    blurb: "Deal 4 · Pick 2 · Burn 2. Both players choose simultaneously; the remaining cards are gone forever." },
];
